import { render, staticRenderFns } from "./SearchObjectsSettings.vue?vue&type=template&id=3d1ac40a&"
import script from "./SearchObjectsSettings.vue?vue&type=script&lang=js&"
export * from "./SearchObjectsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports